import { SoccerGoalAttribute } from '@collector/sportsapi-client-legacy'

import { AttributesToResetParticipants } from '../../configuration'

export const attributesToResetParticipants: AttributesToResetParticipants = [
  SoccerGoalAttribute.OwnGoal,
]
